// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getProductByPath } from "@hardwoods/App/Services/CustomProductServiceV2";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { executeAwaitableHandlerChain } from "@insite/client-framework/HandlerCreator";
import loadProductByPath from "@insite/client-framework/Store/Data/Products/Handlers/LoadProductByPath";
import { chain, LoadProductIfNeeded } from "@insite/client-framework/Store/Pages/ProductDetails/Handlers/DisplayProduct";

export const XngLoadProductIfNeeded: any = async (props: any) => {
    // if variantTypeId is not null this has variantTraits, and we need those loaded fully for this handler chain to work correctly
    if (props.product && props.product.variantTypeId === null) {
        if (
            !props.product.detail ||
            !props.product.content ||
            !props.product.images ||
            !props.product.documents ||
            !props.product.specifications ||
            !props.product.attributeTypes ||
            !props.product.variantTraits
        ) {
            // we don't want to wait for this if we already partially have the product, because then we can't show the partially loaded product page
            props.dispatch(
                loadProductByPath({
                    ...props.parameter,
                    addToRecentlyViewed: true,
                    onComplete: productProps => {
                        const configuration = productProps?.apiResult?.detail?.configuration;
                        if (configuration) {
                            props.dispatch({
                                type: "Pages/ProductDetails/InitConfigurationSelection",
                                configuration,
                            });
                        }
                    },
                }),
            );
        } else {
            // Xng-Change: override getProductByPath to use our custom getProductByPath service
            getProductByPath({ ...props.parameter, addToRecentlyViewed: true, expand: ["attributes"] }).then(result => {
                props.dispatch({
                    type: "Data/Products/CompleteLoadProduct",
                    model: result,
                });
            });
        }

        return;
    }

    props.product = await executeAwaitableHandlerChain(
        loadProductByPath,
        { ...props.parameter, addToRecentlyViewed: true },
        props,
    );
};

replaceInChain(chain, LoadProductIfNeeded, XngLoadProductIfNeeded);
